import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { Stars } from './ReviewCard';

export default function ReviewsSection() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/reviews/public').then(r => setItems(r.data)).catch(() => {}); }, []);
  if (items.length === 0) return null;

  return (
    <section className="mt-32 lg:mt-40 max-w-[1400px] mx-auto px-6 lg:px-12" data-testid="reviews-section">
      <p className="overline">Lo que dicen mis clientas</p>
      <h2 className="font-serif text-5xl lg:text-6xl mt-4 leading-[1.05] max-w-3xl">Casas que ya <em className="italic font-light">se sienten hogar.</em></h2>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map(r => (
          <figure key={r.id} className="border border-stilo-ink/10 bg-stilo-beige p-8 flex flex-col" data-testid={`public-review-${r.id}`}>
            <Stars value={r.rating} size="w-4 h-4" testid={`public-review-stars-${r.id}`} />
            {r.comment && <blockquote className="font-serif text-2xl leading-snug mt-6 flex-1">«{r.comment}»</blockquote>}
            <figcaption className="mt-8">
              <p className="text-sm text-stilo-ink">{r.display_name}</p>
              <p className="overline mt-1">{r.package_name}</p>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
